export var GridTableSortDirection;
(function (GridTableSortDirection) {
    GridTableSortDirection["up"] = "up";
    GridTableSortDirection["down"] = "down";
})(GridTableSortDirection || (GridTableSortDirection = {}));
//# sourceMappingURL=index.types.js.map